<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong>
                A new confirmation link has been sent to your email
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background text-center">
        Please check your email inbox and click on the confirmation link.
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationEmailResent',
};
</script>



// WEBPACK FOOTER //
// src/components/auth/VerificationEmailResent.vue